module.exports = __webpack_public_path__ + "img/prestige.8106096a.png";